import { combineReducers } from 'redux';
import AdminReducer from './admin/reducer';
const rootReducer = combineReducers({
  ERPAdminReducer: AdminReducer
});

export default rootReducer;
